import { render, staticRenderFns } from "./SSelectCarriers.vue?vue&type=template&id=4aa7586b"
import script from "./SSelectCarriers.vue?vue&type=script&lang=js"
export * from "./SSelectCarriers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports